<div class="offcanvas-body mx-0 flex-grow-0">
    <form class="add-new-user pt-0" id="addNewUserForm" onsubmit="return false">
        <div class="input-value">

            <div class="mb-3 p-2" *ngFor="let item of modalData">
                <label class="form-label" [attr.for]="item.key">{{ item.label }}</label>
                <input type="text" class="form-control" [attr.id]="item.key" [attr.placeholder]="item.label"
                    [attr.aria-label]="item.label" [(ngModel)]="item.value"  [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <!-- <div class="mb-3">
            <label class="form-label" for="add-user-email">ایمیل</label>
            <input type="text" id="add-user-email" class="form-control text-start" dir="ltr"
                placeholder="john.doe@example.com" aria-label="john.doe@example.com" name="userEmail">
        </div>
        <div class="mb-3">
            <label class="form-label" for="add-user-contact">تماس</label>
            <input type="text" id="add-user-contact" class="form-control phone-mask" placeholder="+1 (609) 988-44-11"
                aria-label="john.doe@example.com" name="userContact">
        </div>
        <div class="mb-3">
            <label class="form-label" for="add-user-company">شرکت</label>
            <input type="text" id="add-user-company" class="form-control" placeholder="توسعه دهنده وب"
                aria-label="jdoe1" name="companyName">
        </div>
        <div class="mb-3">
            <label class="form-label" for="country">کشور</label>
            <select id="country" class="select2 form-select">
                <option value="">انتخاب</option>
                <option value="Australia">استرالیا</option>
                <option value="Bangladesh">بنگلادش</option>
                <option value="Belarus">بلاروس</option>
                <option value="Brazil">برزیل</option>
                <option value="Canada">کانادا</option>
                <option value="China">چین</option>
                <option value="France">فرانسه</option>
                <option value="Germany">آلمان</option>
                <option value="India">هندوستان</option>
                <option value="Indonesia">اندونزی</option>
                <option value="Iran">ایران</option>
                <option value="Italy">ایتالیا</option>
                <option value="Japan">ژاپن</option>
                <option value="Korea">کره جنوبی</option>
                <option value="Mexico">مکزیک</option>
                <option value="Philippines">فیلیپین</option>
                <option value="Russia">روسیه</option>
                <option value="South Africa">آفریقای جنوبی</option>
                <option value="Thailand">تایلند</option>
                <option value="Turkey">ترکیه</option>
                <option value="Ukraine">اوکراین</option>
                <option value="United Arab Emirates">امارات</option>
                <option value="United Kingdom">انگلستان</option>
                <option value="United States">ایالات متحده</option>
            </select>
        </div>
        <div class="mb-3">
            <label class="form-label" for="user-role">نقش کاربر</label>
            <select id="user-role" class="form-select">
                <option value="subscriber">مشترک</option>
                <option value="editor">ویرایشگر</option>
                <option value="maintainer">نگهدارنده</option>
                <option value="author">نویسنده</option>
                <option value="admin">مدیر</option>
            </select>
        </div>
        <div class="mb-4">
            <label class="form-label" for="user-plan">انتخاب پلن</label>
            <select id="user-plan" class="form-select">
                <option value="basic">پایه</option>
                <option value="enterprise">سازمان</option>
                <option value="company">شرکت</option>
                <option value="team">تیم</option>
            </select>
        </div> -->
        <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit">{{'Submit' | translate}}</button>
        <button type="reset" class="btn btn-label-secondary" data-bs-dismiss="offcanvas">{{'Cancel' | translate}}</button>
    </form>
</div>